import React from 'react';

const LogoSongkickColorSvg = (props) => (
    <svg viewBox="0 0 72 72" {...props}>
        <path
            fill="#fff"
            d="M10.3 7.73C.61 15 1 24.65 1 35s-.39 20 9.3 27.27C17 67.3 24.77 70 36 70s19-2.7 25.7-7.73C71.38 55 71 45.34 71 35s.39-20-9.3-27.26C55 2.71 47.24 0 36 0h-.32zm0 0"
        />
        <path
            fill="#f80046"
            d="M62.44 8A37.94 37.94 0 0 0 45.27.71v32.63l9.78-13.62h10.7L53.43 36.88 58 44.1c1.73 2.71 3.39 3.44 5.9 3.44h1.7V56h-2.66c-5.42 0-8.69-1-11.14-4.74C50.28 48.83 45.27 41 45.27 41v15h-8.94V0H36C24.44 0 16.47 2.78 9.57 8-.4 15.41 0 25.35 0 36s-.4 20.59 9.57 28c6.91 5.17 14.87 8 26.43 8s19.53-2.78 26.44-8C72.4 56.59 72 46.63 72 36s.4-20.58-9.56-28M19.65 56.34c-5.57 0-10.12-1-13.79-4.81l5.72-5.72c1.89 1.89 5.21 2.55 8.12 2.55 3.53 0 5.21-1.17 5.21-3.27a3 3 0 0 0-.71-2.15 4.05 4.05 0 0 0-2.4-1l-4.39-.61c-3.22-.46-5.67-1.53-7.3-3.22s-2.5-4.19-2.5-7.3c0-6.64 5-11.5 13.28-11.5 5.21 0 9.14 1.23 12.26 4.34l-5.62 5.62c-2.3-2.3-5.31-2.15-6.9-2.15-3.12 0-4.39 1.79-4.39 3.37a2.39 2.39 0 0 0 .72 1.69 4.08 4.08 0 0 0 2.5 1.07l4.39.61c3.27.46 5.62 1.48 7.15 3 1.94 1.89 2.7 4.6 2.7 8 0 7.41-6.38 11.45-14 11.45"
        />
    </svg>
);

LogoSongkickColorSvg.displayName = 'LogoSongkickColorSvg';
export default LogoSongkickColorSvg;
